export default __webpack_public_path__ + "static/media/discountPercentage.fe8ddfdd.svg";